import { left } from 'fp-ts/lib/Either';
import {
  useState,
  createContext,
  useContext,
  Dispatch,
  SetStateAction,
  ReactNode,
} from 'react';
import { ErrorCode, IAddress, IUser } from '../interfaces';
import { MAX_INT32 } from '../utils';

interface IUserState {
  user: IUser;
  setUser: Dispatch<SetStateAction<IUser>>;
}

interface IUserContextProviderProps {
  defaults?: Partial<IUser>;
  children?: ReactNode;
}

export const defaultAddress: IAddress = {
  stateCd: '',
  city: '',
  street1: '',
  street2: '',
  street3: '',
  postalCd: '',
};

export const defaultUser: IUser = {
  id: 0,
  // role: "registrant",
  // status: "new",
  // firstName: "John",
  // lastName: "Doe",
  // email: "john.doe@email.com",
  // mi: "A",
  // ssn: "111111111",
  // busPhone: "1111111111",
  // deaRegNum: "F91234563",
  // deaRegName: "SBV",
  // securityCode: "111111111",
  // busName: "CVS Pharmacy",
  // busStreetAddress: "1234 Elm St.",
  // busCity: "ECity",
  // busState: "TA",
  // busZipCode: "12345",
  // csosCoordFirstName: "Sam",
  // csosCoordLastName: "Samson",
  // signature: "John Doe",
  // dateSubmitted: "10/14/2020",
  role: '',
  status: 'new',
  firstName: 'foo',
  lastName: 'bar',
  loginEmail: 'foo@exor-solutions.com',
  middleInitial: '',
  title: 'Developer',
  ssn: '',
  busPhone: '1(703)468-1111',

  organization: 'my organization',
  deaRegNum: 'my DEA Registration Number',
  registrant: 'my reg name',
  coordinator: 'my coordinator',

  securityCode: '',
  busName: '',
  busStreetAddress: '12825 my street',
  busCity: 'my city',
  busState: 'VA',
  busZipCode: '202020',

  csosCoordFirstName: '',
  csosCoordLastName: '',

  signature: '',
  dateSubmitted: '',

  // auth
  userName: '',
  isAuthenticated: false,

  phone: '',
  address: defaultAddress,

  refreshTokenReminderDelay: MAX_INT32,
  accessTokenExpirationDelay: MAX_INT32,

  idExpirationDt: 0,

  groups: [],
  sub: '',

  refreshToken: () =>
    Promise.resolve(left({ code: ErrorCode.NoError, message: '' })),
};

const defaultUserState: IUserState = {
  user: defaultUser,
  setUser: () => {},
};

const UserContext = createContext<IUserState>(defaultUserState);

export const useUserContext = () => {
  return useContext(UserContext);
};

export const UserContextProvider = (props: IUserContextProviderProps) => {
  const [user, setUser] = useState<IUser>({
    ...defaultUser,
    ...props.defaults,
  });

  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
      }}>
      {props.children}
    </UserContext.Provider>
  );
};
